import React, { useState } from 'react';
import { TextField, Button, Box, Grid, FormLabel , InputLabel, FormControlLabel , RadioGroup, Radio, MenuItem, Select } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles  from './useStyles'

const PasoTresForm = () => {


    const classes = useStyles();

    const [subTitulo, setSubTitulo] = useState('Identificación del Juicio Arbitral en Tramitación en la Superintendencia') 

    const handleChangeMediador = (event) => {
      setMediador(event.target.value);
    };


    const [mediador, setMediador] = React.useState('');
   


    return (


    <>
        {/* aca va el sub titulo del formulario */}
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
        </Box>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        <Grid>

        <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Número Ingreso" size="small"  />
        </FormControl>    
       
        <FormControl className={classes.formControlComponent}>
                <TextField
                      id="date"
                      label="Fecha de Ingreso"
                      type="date"
                      variant="outlined"
                      size="small"
                      defaultValue="2022-03-10"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                />
          </FormControl>

   
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>Mediadores Seleccionados (En orden de su preferecia)</h3>
        </Box>

        <FormControl className={classes.formControlComponent} size="small">
           <InputLabel id="selectlabelMediador1" variant="outlined" >Mediador Titular</InputLabel>
           <Select
             required
             labelId="aseguradoralabel"
             id="selectlabelAseguradora"
             variant="outlined"
             value={mediador}
             label="Mediador Titular"
             onChange={handleChangeMediador}
           >
           <MenuItem value={"1"}>Stephens Iriarte</MenuItem>
           <MenuItem value={"2"}>Victor Lopez</MenuItem>
           <MenuItem value={"3"}>Mirian Guanda</MenuItem>
           </Select>
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">
           <InputLabel id="selectlabelMediador2" variant="outlined" >Primer Suplente</InputLabel>
           <Select
             required
             labelId="aseguradoralabel"
             id="selectlabelAseguradora"
             variant="outlined"
             value={mediador}
             label="Primer Suplente"
             onChange={handleChangeMediador}
           >
           <MenuItem value={"1"}>Stephens Iriarte</MenuItem>
           <MenuItem value={"2"}>Victor Lopez</MenuItem>
           <MenuItem value={"3"}>Mirian Guanda</MenuItem>
           </Select>
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">
           <InputLabel id="selectlabelMediador2" variant="outlined" >Segundo Suplente</InputLabel>
           <Select
             required
             labelId="aseguradoralabel"
             id="selectlabelAseguradora"
             variant="outlined"
             value={mediador}
             label="Segundo Suplente"
             onChange={handleChangeMediador}
           >
           <MenuItem value={"1"}>Stephens Iriarte</MenuItem>
           <MenuItem value={"2"}>Victor Lopez</MenuItem>
           <MenuItem value={"3"}>Mirian Guanda</MenuItem>
           </Select>
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small"> </FormControl>

        <Box display="flex" justifyContent="start"  style={{ color: '#184ba3', fontSize: 16, fontWeight: 'bold', marginLeft: 40, marginRight: 40 ,paddingTop: '15px', paddingBottom: '15px' }} >    
                            <TextField fullWidth 
                            id="solicitudconcreta"
                            variant="outlined"
                            label="Descripción del Problema"
                            multiline
                            rows={4}
                        
                            />
                </Box>  
        </Grid>



      </>



  )
}

export default PasoTresForm